"use client";
import { ark } from "../factory.js";
import { useCheckboxContext } from "./use-checkbox-context.js";
import { useFieldContext } from "../field/use-field-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/checkbox/checkbox-hidden-input.tsx
var CheckboxHiddenInput = forwardRef((props, ref) => {
	const mergedProps = mergeProps(useCheckboxContext().getHiddenInputProps(), props);
	const field = useFieldContext();
	return /* @__PURE__ */ jsx(ark.input, {
		"aria-describedby": field?.ariaDescribedby,
		...mergedProps,
		ref
	});
});
CheckboxHiddenInput.displayName = "CheckboxHiddenInput";
//#endregion
export { CheckboxHiddenInput };
